import { useBadgeActions } from '../../../../../ui/features/badge-management/hooks/useBadgeActions';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { MenuIconButton } from '@juvare/common-web-ui/MenuIconButton';
import { requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import ChevronRightIconOutlined from '@mui/icons-material/ChevronRightOutlined';
import MoreHorizIconOutlined from '@mui/icons-material/MoreHorizOutlined';
import { Box, Divider, IconButton } from '@mui/material';
import React from 'react';
export const BadgeListItemActions = ({ badge, fetchBadgeList }) => {
    const { t } = useBadgingTranslation();
    const userState = useUserState();
    const { handleBadgeDetailsEdit, handleBadgeOrganizationsEdit, handleBadgeClick, handleBadgeDuplicateClick } = useBadgeActions({
        badge,
        onSuccess: fetchBadgeList,
    });
    const hasCreatePermission = requireAnySystemPermission(userState, 'manage-badges');
    const moreButtonMenuItems = [
        {
            label: t('common.duplicate'),
            onClick: handleBadgeDuplicateClick,
        },
        {
            label: t('common.editInformation'),
            onClick: handleBadgeDetailsEdit,
        },
        {
            label: t('common.assignOrganization'),
            onClick: handleBadgeOrganizationsEdit,
        },
    ];
    return (React.createElement(Box, { sx: { display: 'flex', gap: 2, width: { xs: '100%', sm: 'auto', flexShrink: 0 } } },
        hasCreatePermission && (React.createElement(React.Fragment, null,
            React.createElement(MenuIconButton, { color: 'primary', size: 'small', menuItems: moreButtonMenuItems, "data-test": 'more-actions-button', anchor: 'right', sx: {
                    ml: { xs: 'auto', sm: 0 },
                } },
                React.createElement(MoreHorizIconOutlined, null)),
            React.createElement(Divider, { orientation: 'vertical', variant: 'middle', flexItem: true }))),
        React.createElement(IconButton, { color: 'primary', size: 'small', onClick: handleBadgeClick },
            React.createElement(ChevronRightIconOutlined, null))));
};
